// Module
var code = `<div class="access-list"></div>`;
// Exports
export default code;